// Shared display names for the enum values MCAP reports on.
//
// The API returns storage keys — AFTER_LUNCH, "calm", ELEMENTARY — and an
// administrator should never be shown one. Kept in a single module because
// the same five states appear on the dashboard, in the drill-down and in the
// PDF, and three copies of this map is three chances for them to disagree.
export const CONTEXT_LABELS = {
  MORNING_MEETING: "Morning meeting",
  TRANSITION: "Transition",
  AFTER_LUNCH: "After lunch",
  RETURN_FROM_RECESS: "Return from recess",
  BEFORE_TEST: "Before a test",
};

// The state a teacher picks describes the class's need, and the label is the
// need — not the reset that answers it. "calm" is the key for a class that is
// Restless.
export const STATE_LABELS = {
  calm: "Restless",
  focus: "Attention Scattered",
  clarity: "Stuck",
  energy: "Low Energy",
  comfort: "Body Tension",
};

export const GRADE_LABELS = {
  EARLY_LEARNING: "Early Learning",
  ELEMENTARY: "Elementary",
  MIDDLE: "Middle",
  HIGH: "High",
  UNSET: "Not set yet",
};

export const BUCKET_LABELS = {
  UNDER_1_MIN: "Under 1 minute",
  ONE_TO_TWO_MIN: "1–2 minutes",
  THREE_TO_FIVE_MIN: "3–5 minutes",
  FIVE_PLUS_MIN: "Over 5 minutes",
};

// Ordered fastest to slowest, and coloured on one deliberate ramp: green for
// back-in-the-lesson quickly, amber for slower, grey for the open-ended bucket
// that contributes no regained minutes. Not a traffic light — a slow return is
// not a failure, it is a class that needed more.
export const BUCKET_COLORS = {
  UNDER_1_MIN: "#227F5D",
  ONE_TO_TWO_MIN: "#4FA37E",
  THREE_TO_FIVE_MIN: "#D9A227",
  FIVE_PLUS_MIN: "#9AA5A0",
};

// Grade bands read as a sequence, so the ramp runs light-to-dark in grade
// order rather than using unrelated hues that imply unrelated things.
export const BAND_COLORS = ["#B49AE8", "#8F6BD8", "#6F42C1", "#54309A", "#3C2270"];
